import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Box, Button, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { SHOPPING_CART_STATUS } from './constants';

const DepartureDockBasketCard = ({ basket, onOpen }) => {
  const status = SHOPPING_CART_STATUS[basket.status];
  const isPending = basket.status === 'Pending';
  const accentColor = status?.color || 'brand.grey.ternary';

  return (
    <Button
      onClick={() => onOpen?.(basket)}
      sx={{
        'p': 0,
        'minHeight': 72,
        'justifyContent': 'stretch',
        'borderRadius': '12px',
        'overflow': 'hidden',
        'width': '100%',
        'textTransform': 'none',
        'border': '1px solid rgba(0,0,0,0.08)',
        'boxShadow': '0 1px 2px rgba(0,0,0,0.06)',
        'backgroundColor': isPending ? '#fff' : '#F3F4F5',
        'color': 'inherit',
        '&:hover': {
          backgroundColor: theme =>
            alpha(theme.palette.brand.blue.secondary, 0.06),
          borderColor: theme => alpha(theme.palette.brand.blue.primary, 0.35),
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 1.5,
          py: 1.25,
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            flexShrink: 0,
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            backgroundColor: accentColor,
          }}
        >
          <ShoppingBasketIcon sx={{ fontSize: 22 }} />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
              color: 'brand.grey.ternary',
              mb: 0.25,
            }}
          >
            {basket.agentName || 'سبد'}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color: isPending ? 'brand.blue.primary' : 'brand.grey.primary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {basket.title}
          </Typography>
          {status?.label ? (
            <Typography
              sx={{
                mt: 0.25,
                fontSize: 11,
                fontWeight: 600,
                color: accentColor,
              }}
            >
              {status.label}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Button>
  );
};

export const DepartureDock = ({ baskets = [], onOpenBasket }) => {
  if (!baskets.length) {
    return (
      <Box
        sx={{
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
        }}
      >
        <Typography color="text.secondary">سبدی در بارانداز نیست.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          xl: 'repeat(4, 1fr)',
        },
        gap: 2,
      }}
    >
      {baskets.map(basket => (
        <DepartureDockBasketCard
          key={basket.guid}
          basket={basket}
          onOpen={onOpenBasket}
        />
      ))}
    </Box>
  );
};
